export const EDIT_COMPANY_USER_REQUEST = 'EDIT_COMPANY_USER_REQUEST'
export const EDIT_COMPANY_USER_RESET = 'EDIT_COMPANY_USER_RESET'
export const EDIT_COMPANY_USER_SUCCESS = 'EDIT_COMPANY_USER_SUCCESS'
export const EDIT_COMPANY_USER_ERROR = 'EDIT_COMPANY_USER_ERROR'
